import { IA_KEY } from 'helpers/ia-logic';
import { NAV_KEY } from 'constants/venue-experience';
import { watchColumnActions, PAGE_LAYOUT_VARIANT } from 'features/App';
import {
  handleRouteEnter,
  watchActions,
  handleViewWaiverRouteEnter,
} from 'features/YieldManagement/YieldManagement.saga';
import { watchExcessInventoryModule } from '../Home/modules/ExcessInventory/ExcessInventory.saga';

import YieldManagementContainer from './YieldManagementContainer';
import ViewWaiverContainer from './ViewWaiverContainer';

export default [
  {
    path: '/classes/:venueId/:startDate/:scheduleId/reservation/:reservationId/waiver/:waiverId/:waiverVersionId',
    component: ViewWaiverContainer,
    navKey: NAV_KEY.CLASSES,
    pathSagas: [handleViewWaiverRouteEnter],
  },
  {
    path: '/classes/:venueId?/:startDate?/:scheduleId?/:tab?',
    component: YieldManagementContainer,
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    hasMultipleColumns: true,
    isFixedPage: true,
    iaKey: IA_KEY.YIELD_MANAGEMENT,
    navKey: NAV_KEY.CLASSES,
    pathSagas: [watchActions, watchColumnActions, handleRouteEnter, watchExcessInventoryModule],
  },
];
